import { apiRequest } from '../../apiCall'

export const getInstruction = (params) => apiRequest('Instruction.GetInstruction', {}, `?CustomerLineId=${params}`);
// export const GetIdentityInfo = (customerId) => apiRequest('OaaIdentity.GetIdentityInfo', {}, `?customerId=${customerId}`);
// export const getCallHistoryByNumber = (params) => apiRequest('CustomerLine.CallHistoryByLineNumber', {},
//     `?lineNumber=+98${params.lineNumber}&callerNumber=${params.callerNumber}&fromDate=${params.from  Data}&toDate=${params.toDate}`);

export const getCallHistoryByExtension = (params, pageData) => apiRequest('CustomerLine.CallHistoryByLineNumber', { ...pageData },
    `?lineNumber=${params.acdExtension}&callerNumber=${params.callerNumber}&fromDate=${params.fromData}&toDate=${params.toDate}`);

export const GetCallAnsweringInstruction = (params) => apiRequest('CustomerLine.GetCallAnsweringInstructionByLineNumber', {},
    `?acdExtension=+98${params}`);


export const GetCallAnsweringCustomerInfo = (params) => apiRequest('CustomerLine.GetCallAnsweringCustomerInfoByLineNumber', {},
    `?acdExtension=+98${params}`);


export const getInstructionList = (params) => apiRequest('Customers.GetLineSecrateryForCustomers', { ...params }, '', true);
export const getِAttachmentById = (params) => apiRequest('CustomerAttachment.getCustomerAttachmentById', params);
export const getِCallReportByCallId = (params) => apiRequest('CustomerLine.GetCallAnswering_Instruction_ByCallReportId', {}, "?callReportId=" + params);
export const saveCallReport = (params) => apiRequest('CallReport.Save', params);
export const editCallReport = (params) => apiRequest('CallReport.Edit', params);
export const getLoginAssRequest = (id) => apiRequest('OaaLogin.GetUrlToLogin', {}, "?customerId=" + id);
export const getAllOperatorRequest = () => apiRequest('Operator.GetAlloperator', {}, "", true);



